import { createApi } from '@reduxjs/toolkit/query/react';
import { identityBaseQuery } from '../../lib/axiosBaseQuery';

export const productsApi = createApi({
  reducerPath: 'productsApi',
  baseQuery: identityBaseQuery,
  tagTypes: ['Products'],
  endpoints: (builder) => ({
    getProducts: builder.query<any, void>({
      query: () => ({
        url: `Product/my-product`,
        method: 'GET',
      }),
      providesTags: ['Products'],
    }),
    uploadDoc: builder.mutation<void, Record<string, any>>({
      query: (data) => ({
        url: `Product/kyc/docs/upload`,
        method: 'POST',
        data,
      }),
    }),
    goLive: builder.mutation<void, void>({
      query: () => ({
        url: `Product/go-live`,
        method: 'GET',
      }),
      invalidatesTags: ['Products'],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useUploadDocMutation,
  useGoLiveMutation,
} = productsApi;
